import { useEffect } from "react";

import { useGetDeviceType } from "_common/hooks/global";
import { formatToRupees }   from "_common/utils";

export function useProModalScrollLock ( opened ) {
	const deviceType = useGetDeviceType ();

	useEffect ( () => {
		const el = document.getElementById ( "right-side-element" );

		if ( !el )
			return;

		if ( deviceType === "mobile" ) {
			el.style.overflow = "unset";

			return;

		}

		if ( opened ) {
			if ( el ) {
				el.style.overflow = "hidden";

				return;
			}

		}

		el.style.overflow = "auto";

	}, [ opened ] );
}

export const benefitsList = ( { avatarsList, selected = {}, couponDetails = {}, order = { content: 1, shop: 2, exclusive: 3 }, productList, userProEligiblity } ) => {
	const contentBenefits = [
		{
			title        : "Streams of all Pro Channels",
			avatarsList  : avatarsList,
			icon         : "proUserProfile",
			avatarsTitle : "View More",
			avatarsType  : "proChannel"
		},
		/* {
      title : "Get access to all “Watch Ad” Streams.",
      icon  : "proAds"
    }, */
		{
			title : "Enjoy video quality up to 1080p",
			icon  : "proHD"
		},
		{
			title : "Seek in Pro Streams",
			icon  : "proPlay"
		},
		{
			title : "Lesser Ads",
			icon  : "proNoAd"
		},
		{
			title : "Pro badge next to your name",
			icon  : "proBadge"
		}
	];

	const rewardsShop = [
		{
			title        : "Up to 10% discount on products",
			avatarsList  : productList,
			icon         : "proOffer",
			avatarsTitle : "Compare Pricing",
			avatarsType  : "shopProducts"
		},
		{
			title : "Up to 10% cashback on all purchases",
			icon  : "proDiamonds"
		},
		{
			title : "Enjoy 3x credit usage",
			icon  : "proRupee"
		},
		{
			title : "Early sale and offer access",
			icon  : "proRedeemCoupon"
		},
		{
			title : "Reserved Inventory for you",
			icon  : "proShop"
		},
		{
			title : "Priority customer support",
			icon  : "proSupport"
		}
	];

	const addedBenefits = [];

	if ( couponDetails?.wallet || selected?.wallet )
		addedBenefits.unshift ( {
			// - Get $ Rooter Diamonds worth Rs.
			title    : "100% Cashback on First Month of Subscription -",
			subtitle : [
				"Step 1 - Purchase Monthly Pro Subscription",
				"Step 2 - Keep your subscription active for atleast 15 Days",
				`Step 3 - On 15th day of your active subscription you will be rewarded with ${ formatToRupees ( couponDetails?.wallet || selected?.wallet ) }  as Cashback in your Rooter Wallet`
			],
			icon: "proDiamonds"
		} );

	/* addedBenefits.push ( {
    title : "Pro App Icon",
    icon  : "proRooterIcon"
  } ); */

	const finalRes = [];

	// Define benefit sections with their data and conditions
	const benefitSections = {
		content: {
			condition : () => contentBenefits?.length,
			data      : {
				title : userProEligiblity ? "CONTENT BENEFITS" : "BENEFITS",
				list  : contentBenefits
			}
		},
		shop: {
			condition : () => userProEligiblity && rewardsShop?.length,
			data      : {
				title : "REWARD & SHOP BENEFITS",
				list  : rewardsShop
			}
		},
		exclusive: {
			condition : () => addedBenefits?.length,
			data      : {
				title : "Exclusive Offer",
				list  : addedBenefits
			}
		}
	};

	// Sort sections by priority and push them
	const sortedSections = Object.keys ( benefitSections )
		.filter ( sectionKey => benefitSections[sectionKey].condition () )
		.sort ( ( a, b ) => {
			const priorityA = order[a];
			const priorityB = order[b];

			// If both have priorities, sort by priority number
			if ( priorityA !== undefined && priorityB !== undefined ) {
				return priorityA - priorityB;
			}

			// If only A has priority, A comes first
			if ( priorityA !== undefined && priorityB === undefined ) {
				return -1;
			}

			// If only B has priority, B comes first
			if ( priorityA === undefined && priorityB !== undefined ) {
				return 1;
			}

			// If neither has priority, maintain original order
			return 0;
		} );

	sortedSections.forEach ( sectionKey => {
		finalRes.push ( benefitSections[sectionKey].data );
	} );

	return finalRes;
};

export const deducePeriod = days => {
	if ( days === 7 )
		return "week";

	if ( days === 30 )
		return "month";

	if ( days === 365 )
		return "year";

	if ( days === 180 )
		return "6 months";

	else return `${ days } days`;
};
/**
 * @param {number} days
 * @returns {string}
 */
export const getPlanName = days => {
	if ( days === 7 )
		return "1 Week";

	if ( days === 30 )
		return "1 Month";

	if ( days === 365 )
		return "1 Year";

	if ( days === 180 )
		return "6 Months";

	else return `${ days } days`;
};
